export default class TemsWebEvents {
    // would be nice to expand this; default options / argument checks, etc.

    public static get MeshUpdated() { return "temsMeshUpdated"; } // args MeshObject, source (optional)

    public static get ToggleDataStream() { return "temsToggleDataStream"; } // args: DeviceDataPointViewModel

    public static get DataStreamDisabled() { return "temsDataStreamDisabled"; } // args: DeviceDataPointViewModel

    public static get DataStreamEnabled() { return "temsDataStreamEnabled"; } // args: DeviceDataPointViewModel

    public static get SiteStateChanged() { return "temsSiteStateChanged"; } // args: SiteState (the new state)

    public static get UserLevelChanged() { return "temsUserLevelChanged"; } // args: none)

    public static get TriggerLinesChanged() { return "temsTriggerLinesChanged"; } // args: deviceId

    public static get DevicePositionChanging() { return "temsDevicePositionChanging"; } // args: deviceId

    public static get DevicePositionChanged() { return "temsDevicePositionChanged"; } // args: deviceId, orientation

    public static get DeviceSensorAssignmentChanged() { return "temsDeviceSensorAssignmentChanged"; } // args: deviceId

    public static get CalibrationObjectChanged() { return "temsCalibrationObjectChanged"; } // args none

    public static get CalibratableDevicesFound() { return "temsCalibratableDevicesFound"; } // args boolean (true if devices found)

    public static get CalibratableDevice() { return "temsCalibratableDevice"; } // args DatapointViewModel

    public static get SceneLoaded() { return "temsSceneLoaded"; } // args: none; called when the SiteView finished loading the scene

    public static get SetSceneFinished() { return "temsSetSceneFinished"; } // args: none; called when the ThreeView SetScene is finished

    public static get LoginRequestFinished() { return "temsLoginRequestFinished"; } // args: HttpStatusCode; called when Ajax LoginRequest enters done() or fail()

    public static get ElementSelected() { return "temsElementSelected"; } // args: id; called when an element was selected

    public static subscribeEvent(temsWebEvent: string, handler: JQuery.EventHandlerBase<any, JQuery.TriggeredEvent>): void {
        $(document).on(temsWebEvent, handler);
    }

    public static unsubscribeEvent(temsWebEvent: string, handler: JQuery.EventHandlerBase<any, JQuery.TriggeredEvent>): void {
        $(document).off(temsWebEvent, null, handler);
    }

    public static publishEvent(temsWebEvent: string, parameters?: any[]) {
        $(document).trigger(temsWebEvent, parameters);
    }
}
